import { type Enum } from '@webapp/infrastructure/types/Enum'

export const RequestTypes = {
  ORDER: 'ORDER',
  EXPENSE: 'EXPENSE',
  TRAVEL: 'TRAVEL',
  PAY_REQUEST: 'PAY_REQUEST',
} as const
export type RequestTypeEnum = Enum<typeof RequestTypes>
